exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media (min-width:768px){#category.layout .master .sidebar{top:6rem}}", ""]);

